
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import Timeline from '@/components/Timeline.vue'
import News from '@/components/News.vue'

import COVERAPP from '@/utils/COVERAPP'
import Config from '@/utils/config'

@Options({
    data() {
      return {
        kb: [],
        jy: [],
        zj: [],
        lk: [],
        qz: [],
      }
    },
    computed: {
        ...mapState(['userInfo', 'shareData', 'activityData'])
    },
    components: {
      Timeline,
      News,
    },
    created() {
      this.getList();
    },
    mounted () {
        this.$common.pageLoaded()
        let homeShareData = JSON.parse(JSON.stringify(this.shareData))
        homeShareData.link = window.location.href
        this.$common.onshare(homeShareData)
        this.$common.track('load', '进入首页')
    },
    methods: {
      ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_ACTIVITYDATA']),
      getList() {
        this.$http('/wap/getSubjectInfo', {
          subject_id: 9512
        }).then(res => {
          const list = res.list;
          list.forEach(item => {
            if (item.category_id == 7411) {
              this.kb = item.news;
            }

            if (item.category_id == 7412) {
              this.jy = item.news;
            }

            if (item.category_id == 7415) {
              this.zj = item.news;
            }

            if (item.category_id == 7413) {
              this.lk = item.news;
            }

            if (item.category_id == 7422) {
              this.qz = item.news;
            }
          });

          this.SET_SHAREDATA({
            title: res.share_title,
            desc: res.subject_desc,
            imgUrl: 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
            link: window.location.href
          })
        });
      },
      cateLink(id) {
        if (COVERAPP.Attribute.isApp()) {
          return `${Config.APP_SCHEME_URL}/news?id=0&flag=204&subjectid=9512&catename=云求助&cateid=${ id }`;
        } else {
          return `https://m.thecover.cn/subject_detail.html?subjid=9512&cateid=${ id }`;
        }
      },
    },
})
export default class Home extends Vue {}
